/* eslint global-require: 0 */
const React = require('react')


if (process.env.CONFIG === 'landings.dev') {
  const { Portal } = require('react-portal')

  module.exports = ({ children }) => (
    <Portal>
      <div>
        {children}
      </div>
    </Portal>
  )
}
else {
  module.exports = ({ children }) => (
    <div data-react-universal-portal>
      {children}
    </div>
  )
}
